import { render, staticRenderFns } from "./SelectorCategoria.vue?vue&type=template&id=2aba0881&scoped=true&"
import script from "./SelectorCategoria.vue?vue&type=script&lang=js&"
export * from "./SelectorCategoria.vue?vue&type=script&lang=js&"
import style0 from "./SelectorCategoria.vue?vue&type=style&index=0&id=2aba0881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba0881",
  null
  
)

export default component.exports